import { SettingsActionTypes } from './types'

export const fetchSettingsPending = () => ({
  type: SettingsActionTypes.FETCH_SETTINGS_PENDING
})

export const fetchSettingsFulfilled = (data: Record<string, any>) => ({
  type: SettingsActionTypes.FETCH_SETTINGS_FULFILLED,
  payload: data
})

export const fetchSettingsRejected = (error: string) => ({
  type: SettingsActionTypes.FETCH_SETTINGS_REJECTED,
  payload: error
})
